//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PurchaseCreditNoteCreateView from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteCreate'
import PurchaseCreditNoteListView from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteList'
import PurchaseCreditNoteUpdateView from '@/views/Purchase/PchPurchaseCreditNote/PchPurchaseCreditNoteUpdate'

//
export default {
    path: 'purchase_credit_note',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-credit-note-list',
            component: PurchaseCreditNoteListView,
        },
        {
            path: 'create',
            name: 'purchase-credit-note-create',
            component: PurchaseCreditNoteCreateView,
            meta: {
                title: 'Crear nomina de pago',
            },
        },
        {
            path: ':id',
            name: 'purchase-credit-note-update',
            component: PurchaseCreditNoteUpdateView,
            meta: {
                title: 'Detalle de nota de credito',
            },
        },
    ],
    meta: {
        title: 'Notas de credito',
    },
}
